export const phantomModalContents = [
    {
        name: 'Combattant',
        content: [
            <p>
                Habile au maniement de l'<span className='text-pborange'>épée</span> , adepte des attaques physiques,
                c'est à l'<span className='text-pborange'>avant-garde</span> qu'il fait des merveilles.
            </p>,
            <p>
                Il possède une compétence unique grâce à laquelle plus il est entouré d'ennemis, plus son attaque gagne
                en puissance. Cela signifie qu'il{' '}
                <span className='text-pborange'>montre le meilleur de lui-même dans les situations difficiles</span> !
            </p>,
            <p>
                Il peut apprendre de nombreuses compétences. Par exemple, s'il est{' '}
                <span className='text-pborange'>équipé d'une arme de corps à corps</span> quand sa puissance physique et
                sa puissance de défense augmentent, son tour reviendra plus rapidement.
            </p>,
        ],
    },
    {
        name: 'Sorcière',
        content: [
            <p>
                Type de personnage se spécialisant dans les <span className='text-pborange'>attaques magiques</span>.
            </p>,
            <p>
                Même si elle excelle dans l'<span className='text-pborange'>attaque à distance des ennemis</span>, elle
                est <span className='text-pborange'>physiquement très faible</span>. Assurez-vous de la protéger avec
                une classe comme le combattant !
            </p>,
            <p>
                Ses valeurs de Reste et de Déplacement sont inférieures à celles du combattant, alors veillez à ne pas
                la déployer trop tôt et à ce qu'
                <span className='text-pborange'>elle ne disparaisse pas avant d'avoir pu attaquer</span>.
            </p>,
        ],
    },
    {
        name: 'Archère',
        content: [
            <p>
                Personnage se spécialisant dans l'utilisation des arcs. Elle peut attaquer à partir des{' '}
                <span className='text-pborange'>rangs arrière</span>.
            </p>,
            <p>
                Elle inflige plus de dégâts en{' '}
                <span className='text-pborange'>
                    attaquant les ennemis à partir d'une grande hauteur. Elle est idéale pour les niveaux offrant
                    beaucoup de positions avantageuses
                </span>
                .
            </p>,
            <p>
                Elle est vulnérable aux attaques, et ne tient pas longtemps quand elle est à portée d'un ennemi.
                Utilisez la hauteur et la distance à votre avantage pour{' '}
                <span className='text-pborange'>empêcher l'ennemi de trop se rapprocher</span>.
            </p>,
        ],
    },

    {
        name: 'Attaquante',
        content: [
            <p>
                <span className='text-pborange'>Combattante d'avant-garde</span>, armée d'une{' '}
                <span className='text-pborange'>lance</span> et dotée d'une défense physique élevée.
            </p>,
            <p>
                Possède la capacité unique d'augmenter sa puissance d'attaque en se déplaçant, ce qui en fait une bonne
                <span className='text-pborange'>combattante mobile</span>.
            </p>,
            <p>
                Possède une défense physique élevée, mais une{' '}
                <span className='text-pborange'>défense magique faible</span>, alors faites attention !
            </p>,
        ],
    },
    {
        name: 'Sorcier',
        content: [
            <p>
                <span className='text-pborange'>Possède des sorts dont la zone d'effet est plus importante</span> que
                ceux de la Sorcière, ce qui lui permet d'attaquer plus d'ennemis à partir de l'arrière.
            </p>,
            <p>
                Tout comme la Sorcière, il a une défense physique faible et peu de mobilité. Cependant, si vous arrivez
                à gérer ces faiblesses, vous pourrez compter sur lui pour régler leur compte à{' '}
                <span className='text-pborange'>plusieurs ennemis</span>.
            </p>,
        ],
    },
    {
        name: 'Guérisseuse',
        content: [
            <p>
                Non seulement cette classe est dotée de capacités de soin, mais elle peut aussi augmenter la défense de
                tous ses alliés à portée, ce qui lui permet de remplir son rôle en étant simplement déployé{' '}
                <span className='text-pborange'>à l'arrière-garde</span>.
            </p>,
            <p>
                Nécessaire pour l'<span className='text-pborange'>installation</span> de soin. Votre aventure sera donc
                facilitée si vous en avez au moins une dans vos rangs.
            </p>,
        ],
    },
    {
        name: 'Mécanicienne',
        content: [
            <p>
                <span className='text-pborange'>Classe unique</span> qui vous permet d'utiliser les compétences liées
                aux Gadgets, comme accumuler plus de Mana.
            </p>,

            <p>
                Sa véritable utilité se dévoile dès que des <span className='text-pborange'>Gadgets</span> sont présents
                sur la carte. Déployez-la avec Abricot, et admirez leur puissance dans toute sa splendeur !
            </p>,
        ],
    },
    {
        name: 'Expert',
        content: [
            <p>
                <span className='text-pborange'>Puissant combattant d'avant-garde</span>, capable d'utiliser n'importe
                quelle arme de corps-à-corps.
            </p>,
            <p>
                Même s'il dispose de certaines compétences particulières, son <span className='text-pborange'>attaque et sa défense élevées</span> le rendent
                très utile au combat.
            </p>,
            <p>
                Il disparaît cependant après seulement 2 tours, aussi est-il <span className='text-pborange'>préférable de le garder pour les phases où
                vous avez besoin d'une force de frappe conséquente</span>.
            </p>,
        ],
    },
    {
        name: 'Nécromante',
        content: [
            <p>
                Classe de magie humanoïde d'arrière-garde la plus puissante. Possède une INT et une défense magique
                élevées, ce qui affecte sa capacité à lancer des sorts, ainsi qu'une <span className='text-pborange'>RÉS élevée, ce qui affecte les
                soins</span>.
            </p>,
            <p>
                Peut aussi obtenir des compétences qui augmentent la portée et la zone d'effet des Capacités d'action.
            </p>,
            <p>
                Cependant, tout comme l'Expert, elle disparaît après seulement 2 tours. Il est donc <span className='text-pborange'>très important de
                bien choisir quand l'utiliser</span>.
            </p>,
        ],
    },

    {
        name: 'Matelot',
        content: [
            <p>
                Unité de moyenne-garde particulière qui ne possède ni compétence spéciale, ni spécialité. En revanche,
                cette unité est celle qui <span className='text-pborange'>peut rester le plus grand nombre de tours</span> avant de disparaître.
            </p>,
            <p>
                Les compétences de cette classe en font la cible des attaques, ce qui la rend très utile pour <span className='text-pborange'>protéger
                les alliés les plus faibles</span>.
            </p>,
            <p>
                Entraînez cette classe pour qu'elle reçoive de nombreuses compétences, comme la possibilité d'augmenter
                sa valeur Reste, de recevoir plus d'EXP, de réduire l'utilisation des PC, et bien d'autres <span className='text-pborange'>capacités
                uniques</span>. Le simple fait de créer un Matelot constituera sans doute un bon exercice d'entraînement !
            </p>,
        ],
    },
    {
        name: 'Combattant Chèvre',
        content: [
            <p>Guerrier exceptionnel de la tribu des Chèvres, doté de la capacité de <span className='text-pborange'>repousser</span> ses ennemis.</p>,
            <p>
                Sa puissance d'attaque augmente quand il se déplace, et ses autres compétences augmentent quand d'autres
                unités de la tribu des Chèvres sont présentes sur la carte, ce qui en fait une classe facile à
                <span className='text-pborange'>renforcer</span>.
            </p>,
            <p>Cependant, il est extrêmement faible face à la magie, alors faites attention !</p>,
        ],
    },
    {
        name: 'Garde marine',
        content: [
            <p>Guerrière des Marines, dotée de <span className='text-pborange'>puissantes défenses</span> et capable de protéger ses alliés.</p>,
            <p>
                Peut correctement protéger ses alliés grâce aux caractéristiques des Marines, comme l'<span className='text-pborange'>immunité aux
                altérations d'état</span> et une <span className='text-pborange'>défense magique élevée</span>.
            </p>,
            <p>Ses compétences augmentent quand d'autres unités des Marines se trouvent sur la carte.</p>,
        ],
    },
    {
        name: 'Flingueur hibou',
        content: [
            <p>
                Classe de la tribu des Hiboux, qui utilise les armes à feu et dispose d'une <span className='text-pborange'>puissance de SAUT élevée</span>.
            </p>,
            <p>Ses compétences augmentent quand d'autres unités de la tribu des Hiboux sont présentes sur la carte.</p>,
            <p>
                Peut jouer avec ses proies en les dégommant à partir de <span className='text-pborange'>positions élevées</span>, tout en évitant les
                représailles.
            </p>,
        ],
    },
]
